import { render } from "./IconPenalty.vue?vue&type=template&id=655c8d08&ts=true"
import script from "./IconPenalty.vue?vue&type=script&lang=ts"
export * from "./IconPenalty.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__